export default "__VITE_ASSET__BSAzalDx__"